import styled from 'styled-components';

const EditorStyle = styled.div`
	white-space: pre-wrap;

	font-size: var(--p3);
	font-family: var(--montserrat_arm);
	font-weight: 400;
	line-height: var(--lineHeightS);
	color: var(--mainColor);

	&.faq-version {
		font-size: var(--p4);

		p,
		a,
		li,
		blockquote {
			font-size: var(--p4);
		}
	}

	h5 {
		font-size: var(--h5);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		color: var(--mainColor);
		line-height: var(--lineHeightS);
	}

	h6 {
		font-size: var(--h6);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		color: var(--mainColor);
		line-height: var(--lineHeightS);
	}

	p {
		font-size: var(--p3);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeight);
		color: var(--mainColor);
	}

	a {
		/* font-size: var(--p3);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeight); */
		color: var(--mainColor);
		text-decoration: underline;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					text-decoration: none;
				}
			}
		}
	}

	strong {
		font-weight: 600;
	}

	ol {
		list-style-position: inside;

		li {
			font-size: var(--p3);
			font-family: var(--montserrat_arm);
			font-weight: 400;
			line-height: var(--lineHeight);
			color: var(--mainColor);
		}
	}

	ul {
		list-style: disc;
		list-style-position: inside;

		li {
			font-size: var(--p3);
			font-family: var(--montserrat_arm);
			font-weight: 400;
			line-height: var(--lineHeight);
			color: var(--mainColor);
		}
	}

	blockquote {
		border-left: 3px solid var(--mainColor);
		padding-left: 2vw;
		font-size: var(--p3);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeight);
		color: var(--mainColor);
	}
`;

export default EditorStyle;
